// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function compact(obj: Record<string, any>): Record<string, any> {
  return Object.keys(obj).reduce((result, key) => {
    if (obj[key]) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      // eslint-disable-next-line no-param-reassign
      result[key] = obj[key];
    }
    return result;
  }, {});
}

// Flattens nested object
// source: https://gist.github.com/penguinboy/762197
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function flatten(obj: Record<string, any>): Record<string, any> {
  const toReturn = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const i in obj) {
    // eslint-disable-next-line no-prototype-builtins, no-continue
    if (!obj.hasOwnProperty(i)) continue;

    if (typeof obj[i] === "object") {
      const flatObject = flatten(obj[i]);
      // eslint-disable-next-line no-restricted-syntax
      for (const x in flatObject) {
        // eslint-disable-next-line no-prototype-builtins, no-continue
        if (!flatObject.hasOwnProperty(x)) continue;

        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        toReturn[`${i}.${x}`] = flatObject[x];
      }
    } else {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      toReturn[i] = obj[i];
    }
  }
  return toReturn;
}

export function ensureFlat<T>(flatOrArray: T | T[]): T {
  if (flatOrArray === null) {
    // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'T'.
    return null;
  }

  if (flatOrArray === undefined) {
    // @ts-expect-error TS(2322): Type 'undefined' is not assignable to type 'T'.
    return undefined;
  }

  return Array.isArray(flatOrArray) ? flatOrArray[0] : flatOrArray;
}

export function ensureArray<T>(flatOrArray: T | T[]): T[] {
  if (flatOrArray === null) {
    // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'T[]'.
    return null;
  }

  if (flatOrArray === undefined) {
    // @ts-expect-error TS(2322): Type 'undefined' is not assignable to type 'T[]'.
    return undefined;
  }

  return Array.isArray(flatOrArray) ? flatOrArray : [flatOrArray];
}
